// The brownfield bridge is only provided by the native iOS and Android shells.
// Keeping a web-specific module prevents react-native-web from evaluating
// TurboModuleRegistry, which is not available in browser and Storybook builds.
export default null
